/**
 * Created by Michał Stawski on 2017-12-27.
 */

import { axiosApi } from '../App'
import jwtDecode from 'jwt-decode'
import { schemaClientGet } from './restApi'
import * as moment from 'moment'

let user = JSON.parse(localStorage.getItem('user'))
let refresh = JSON.parse(localStorage.getItem('refresh'))

const initialState = (user && refresh) ?
  { loggedIn: true, user, refresh }
  :
  { loggedIn: false }

const userConstants = {
  // REGISTER_REQUEST: 'USERS_REGISTER_REQUEST',
  REGISTER_SUCCESS: 'USERS_REGISTER_SUCCESS',
  REGISTER_FAILURE: 'USERS_REGISTER_FAILURE',

  // LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
  LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
  LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',

  // RELOGIN_SUCCESS: 'USERS_RELOGIN_SUCCESS',
  // RELOGIN_FAILURE: 'USERS_RELOGIN_FAILURE',
  LOGOUT: 'USERS_LOGOUT',
}

/*
  ("app_rrev", "Access to RRev App"),
  ("app_forecast", "Access to Forecast App"),
  ("app_performance", "Access to Hotel Performance App"),
  ("app_best_clients", "Access to Best Clients App"),
  ("app_key_clients", "Access to Key Clients App"),
  ("app_manual_sales", "Access to Manual Sales App"),
*/

// TODO autogenerate from python sources
export const permissions = {
  APP_FILE_LIST: 'pcms.app_file_list',
  APP_USER_MANAGEMENT: 'pcms.app_user_management',
}

export { userConstants }

export default function authentication (state = initialState, action) {
  switch (action.type) {
    case userConstants.LOGIN_SUCCESS:
      // let csrfToken = Cookies.get('csrftoken')
      localStorage.setItem('user', JSON.stringify(action.user))
      localStorage.setItem('refresh', JSON.stringify(action.refresh))

      // axiosApi.defaults.headers['X-CSRFToken'] = csrfToken
      axiosApi.defaults.headers['Authorization'] = 'Bearer ' + action.access
      return {
        loggedIn: true,
        user: action.user,
        refresh: action.refresh,
        access: action.access,
        refreshed: true,
        exp: action.exp
      }
    case userConstants.LOGIN_FAILURE:
      return { loggedIn: false, error: action.error }
    case userConstants.LOGOUT:
      localStorage.setItem('user', null)
      localStorage.setItem('refresh', null)
      delete axiosApi.defaults.headers['Authorization']
      return { loggedIn: false }
    default:
      return state
  }
}

export const sendLogin = (values, dispatch, props) => {
  let { username, password } = values
  axiosApi.post('/api/token/', { username, password })
    .then((ret) => {
      // TODO no need to check status?
      let decoded = jwtDecode(ret.data['refresh'])

      dispatch({
        type: userConstants.LOGIN_SUCCESS, user: decoded.user,
        refresh: ret.data.refresh, access: ret.data.access, exp: decoded.exp
      })
      dispatch(schemaClientGet())
    }, (ret) => {
      dispatch({ type: userConstants.LOGIN_FAILURE, error: ret })
      console.error('error', ret)
    }).catch((ret) => {
    dispatch({ type: userConstants.LOGIN_FAILURE, error: ret })
    console.error('error', ret)
  })
  return {}
}
export const reLogin = (dispatch) => (authorization) => {
  if (authorization && authorization.loggedIn) {
    return axiosApi.post('/api/token/refresh/', { refresh: authorization.refresh })
      .then((ret) => {
        let decoded = jwtDecode(ret.data['access'])
        dispatch({
          type: userConstants.LOGIN_SUCCESS, user: decoded.user,
          refresh: authorization.refresh, access: ret.data.access, exp: decoded.exp
        })
      }, (ret) => {
        dispatch({ type: userConstants.LOGIN_FAILURE, error: ret })
        console.error('error', ret)
      }).catch((ret) => {
        dispatch({ type: userConstants.LOGIN_FAILURE, error: ret })
        console.error('error', ret)
      })
  } else {
    // don't do anything if the user is not yet logged in
    return Promise.resolve()
  }
}
export const logout = (dispatch) => () => {
  console.log('try logout')
  dispatch({ type: userConstants.LOGOUT })
  //  TODO send logout request to server and add to blacklist for security
  // axiosApi.post('/api/json_logout/').then((ret) => {
  //   dispatch({ type: userConstants.LOGOUT })
  //   window.location = '/login/'
  // })
  return {}
}

export const checkNeedToRelogin = (dispatch) => (authorization) => {
  if ((moment.unix(authorization.exp).utc() - moment.utc()) < 1000 * 60 * 5) {
    return reLogin(dispatch)(authorization)
  } else {
    return Promise.resolve()
  }

}
